import { FilterConfig } from '../models/filter-config.model';

// TODO: THIS WILL BE DELETED AFTER OPTIONS WILL BE KNOWN OR BE WILL PROVIDE THEM FROM
export const filterConfigMock: FilterConfig = {
  display: [
    { label: 'Installed audience', value: 'installed_audience' },
    { label: 'Active users', value: 'active_users' },
  ],
  viewBy: [
    { label: 'Android versions', value: 'android_versions' },
    { label: 'Device Types', value: 'device_types' },
  ],
  interval: [
    { label: 'Last 30 days', value: 'last_30_days' },
    { label: 'Last 7 days', value: 'last_7_days' },
  ],
};
